import { createAction, props } from '@ngrx/store';

import { Catalog, CatalogPage } from '../../interfaces/entity-interfaces';

export enum CatalogActions {
    LoadCatalogs = `[Catalog] Load Catalogs`,
    SetCatalogs = `[Catalog] Set Catalogs`,
    LoadCatalog = `[Catalog] Load Catalog`,
    SetCatalog = `[Catalog] Set Catalog`,
    ClearCatalog = `[Catalog] Clear Catalog`,
    SetCatalogPages = `[Catalog] Set Catalog Pages`,
    SetSaving = `[Catalog] Set Saving`,
}

export const loadCatalogs = createAction(CatalogActions.LoadCatalogs);

export const setCatalogs = createAction(CatalogActions.SetCatalogs, props<{ payload: Catalog[] }>());

export const loadCatalog = createAction(CatalogActions.LoadCatalog, props<{ payload: { id: number } }>());

export const setCatalog = createAction(CatalogActions.SetCatalog, props<{ payload: Catalog }>());

export const clearCatalog = createAction(CatalogActions.ClearCatalog);

export const setCatalogPages = createAction(CatalogActions.SetCatalogPages, props<{ payload: CatalogPage[] }>());

export const setCatalogSaving = createAction(CatalogActions.SetSaving, props<{ payload: boolean }>());
